(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compre-junto-inferior"] && !Shopify.designMode) return;
  try {
    
  (function initCompreJuntoInferior() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCompreJuntoInferior);
      return;
    }

    const mainProductElementInferior = document.querySelector('.main-product-inferior');
    const items_inferior = document.querySelectorAll('.compre-junto-inferior-item');
    const totalPriceElementInferior = document.getElementById('total-price-inferior');
    const totalPricePixElementInferior = document.getElementById('total-price-inferior-pix');
    const totalContainerInferior = document.querySelector('.compre-junto-inferior-total');
    const addButtonInferior = document.querySelector('.compre-junto-inferior-btn');

    // Lido do atributo (que vem das configurações do tema via Liquid),
    // não fixo aqui — fica em sincronia se a porcentagem do pix mudar.
    const pixDiscountPercentageInferior = totalContainerInferior
      ? parseFloat(totalContainerInferior.getAttribute('data-pix-discount-percentage')) || 0
      : 0;

    let mainVariantIdInferior;
    let mainVariantPriceInferior;

    function updateTotalInferior() {
      let total = 0;
      let selectedItemsInferior = [];
      items_inferior.forEach(item => {
        if (item.getAttribute('data-selected') === 'true') {
          total += parseFloat(item.getAttribute('data-price'));
          selectedItemsInferior.push(item.getAttribute('data-id'));
        }
      });
      totalPriceElementInferior.textContent = total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

      if (totalPricePixElementInferior) {
        const pixTotal = total - (total * (pixDiscountPercentageInferior / 100));
        totalPricePixElementInferior.textContent = pixTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      }

      addButtonInferior.disabled = selectedItemsInferior.length <= 1;
    }

function updateMainProductInCompreJuntoInferior(variantId) {
  const mainSelect = mainProductElementInferior.querySelector('.compre-junto-inferior-select-variant');
  if (!mainSelect) {
    console.warn("Seletor de variante principal do Compre Junto Inferior não encontrado.");
    return;
  }

  const optionToSelect = Array.from(mainSelect.options).find(option => parseInt(option.value) === variantId);

  if (optionToSelect) {
    mainSelect.value = variantId;
    const newCurrentPrice = parseFloat(optionToSelect.getAttribute('data-current-price'));
    const newComparePrice = parseFloat(optionToSelect.getAttribute('data-compare-price'));
    const newImage = optionToSelect.getAttribute('data-image');

    mainVariantIdInferior = parseInt(optionToSelect.value);
    mainVariantPriceInferior = newCurrentPrice;

    mainProductElementInferior.setAttribute('data-id', mainVariantIdInferior);
    mainProductElementInferior.setAttribute('data-price', newCurrentPrice);

    const imgElement = mainProductElementInferior.querySelector('.compre-junto-inferior-item-image-display');
    if (imgElement) {
      imgElement.src = newImage;
    }

    const newPriceElement = mainProductElementInferior.querySelector('.compre-junto-inferior-new-price');
    const oldPriceElement = mainProductElementInferior.querySelector('.compre-junto-inferior-old-price');

    if (newPriceElement) {
      newPriceElement.textContent = newCurrentPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    if (oldPriceElement) {
      if (newComparePrice > newCurrentPrice) {
        oldPriceElement.textContent = newComparePrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        oldPriceElement.style.display = 'inline';
      } else {
        oldPriceElement.textContent = '';
        oldPriceElement.style.display = 'none';
      }
    }
    updateTotalInferior();
  } else {
    console.warn(`Variante ${variantId} não encontrada no select do Compre Junto Inferior para o produto principal. Mantendo estado atual.`);
  }
}

items_inferior.forEach(item => {
  if (item.classList.contains('main-product-inferior')) {
    item.setAttribute('data-selected', 'true');
    const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');
    if (checkboxCircle) checkboxCircle.classList.add('checked');
    return;
  }

  const selectionBox = item.querySelector('.compre-junto-inferior-selection-box');
  const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');

  if (selectionBox && checkboxCircle) {
    const isUnavailable = selectionBox.getAttribute('data-disabled') === 'true';

    if (isUnavailable) {
      item.setAttribute('data-selected', 'false');
      checkboxCircle.classList.remove('checked');
      item.classList.add('compre-junto-inferior-item-unavailable');
    } else {
      selectionBox.addEventListener('click', function (e) {
        e.stopPropagation();
        const isSelected = item.getAttribute('data-selected') === 'true';
        item.setAttribute('data-selected', !isSelected ? 'true' : 'false');
        checkboxCircle.classList.toggle('checked', !isSelected);
        updateTotalInferior();
      });
    }
  }
});



    document.querySelectorAll('.compre-junto-inferior-select-variant').forEach(function (selectElement) {
      const parentItem = selectElement.closest('.compre-junto-inferior-item');
      if (!parentItem) return;

      if (!parentItem.classList.contains('main-product-inferior')) {
          const initialSelectedOption = selectElement.options[selectElement.selectedIndex];
          const initialCurrentPrice = parseFloat(initialSelectedOption.getAttribute('data-current-price'));
          const initialComparePrice = parseFloat(initialSelectedOption.getAttribute('data-compare-price'));
          const initialImage = initialSelectedOption.getAttribute('data-image');

          parentItem.setAttribute('data-id', initialSelectedOption.value);
          parentItem.setAttribute('data-price', initialCurrentPrice);

          const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
          if (imgElement) {
            imgElement.src = initialImage;
          }

          const newPriceElement = parentItem.querySelector('.compre-junto-inferior-new-price');
          const oldPriceElement = parentItem.querySelector('.compre-junto-inferior-old-price');

          if (newPriceElement) {
            newPriceElement.textContent = initialCurrentPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          }

          if (oldPriceElement) {
            if (initialComparePrice > initialCurrentPrice) {
              oldPriceElement.textContent = initialComparePrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              oldPriceElement.style.display = 'inline';
            } else {
              oldPriceElement.textContent = '';
              oldPriceElement.style.display = 'none';
            }
          }
      }


      selectElement.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const newVariantId = parseInt(selectedOption.value);
        const newCurrentPrice = parseFloat(selectedOption.getAttribute('data-current-price'));
        const newComparePrice = parseFloat(selectedOption.getAttribute('data-compare-price'));
        const newImage = selectedOption.getAttribute('data-image');

        if (parentItem.classList.contains('main-product-inferior')) {
          updateMainProductInCompreJuntoInferior(newVariantId);
        } else {
          parentItem.setAttribute('data-id', newVariantId);
          parentItem.setAttribute('data-price', newCurrentPrice);

          const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
          if (imgElement) {
            imgElement.src = newImage;
          }

          const newPriceElement = parentItem.querySelector('.compre-junto-inferior-new-price');
          const oldPriceElement = parentItem.querySelector('.compre-junto-inferior-old-price');

          if (newPriceElement) {
            newPriceElement.textContent = newCurrentPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
          }

          if (oldPriceElement) {
            if (newComparePrice > newCurrentPrice) {
              oldPriceElement.textContent = newComparePrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              oldPriceElement.style.display = 'inline';
            } else {
              oldPriceElement.textContent = '';
              oldPriceElement.style.display = 'none';
            }
          }
          updateTotalInferior();
        }
      });
    });


 addButtonInferior.addEventListener('click', function () {
   addButtonInferior.disabled = true;
   const originalButtonText = addButtonInferior.textContent;
   addButtonInferior.textContent = 'Adicionando...';
 
   const itemsToAddInferior = [];
   items_inferior.forEach(item => {
  if (item.getAttribute('data-selected') === 'true') {
    itemsToAddInferior.push({
   id: parseInt(item.getAttribute('data-id')),
   quantity: 1
    });
  }
   });
 

   const sectionsToRender = ["cart-notification-product", "cart-notification-button", "cart-icon-bubble", "cart-upsell", "cart-drawer-gift"];

   fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    items: itemsToAddInferior,
    sections: sectionsToRender,
    sections_url: window.location.pathname
  })
   })
   .then(response => {
  if (!response.ok) {
    return response.json().then(error => { throw new Error(error.description || 'Erro desconhecido'); });
  }
  return response.json();
   })
   .then(parsedState => {
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.renderContents === 'function') {
    cartNotification.renderContents(parsedState);
  }
  if (typeof openCartDrawer === 'function') {
    openCartDrawer();
  }

  setTimeout(() => {
    addButtonInferior.textContent = originalButtonText;
    updateTotalInferior();
  }, 1500);
   })
   .catch((error) => {
  console.error('Erro ao adicionar itens ao carrinho:', error);
  addButtonInferior.textContent = 'Erro!';
  setTimeout(() => {
    addButtonInferior.textContent = originalButtonText;
    updateTotalInferior();
  }, 2500);
   });
 });
 

    
    function syncItemVisuals(item) {
      const select = item.querySelector('.compre-junto-inferior-select-variant');
      if (!select) return; 
    
      select.dispatchEvent(new Event('change'));
    }
    
    window.addEventListener('pageshow', function() {
      items_inferior.forEach(syncItemVisuals);
    });
    
    items_inferior.forEach(syncItemVisuals);

    updateTotalInferior();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
